// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"720c1e906e7de010c159","655":"e6c30d2a8ca4af5384d7"}[chunkId] + ".js";
};